import React, { useEffect, useState, Suspense } from "react";
import { isDebugEnabled, setDebugEnabled, installHashToggleOnce } from "@/lib/debugFlag";

const LazyPanel = React.lazy(() =>
  import("@/debug/DebugPanel").catch((e) => {
    console.error("[QuickQuiz] Failed to load DebugPanel", e);
    // Provide a dummy component on failure
    return {
      default: () => (
        <div
          style={{
            position: "fixed",
            right: 16,
            bottom: 60,
            zIndex: 999999,
            background: "#fee",
            color: "#900",
            padding: "8px 10px",
            borderRadius: 8,
            boxShadow: "0 2px 10px rgba(0,0,0,.2)",
            fontSize: 12,
          }}
        >
          Debug panel failed to load (see console)
        </div>
      ),
    };
  })
);

export default function DebugButton() {
  const [enabled, setEnabled] = useState(isDebugEnabled());
  const [open, setOpen] = useState(isDebugEnabled());

  useEffect(() => {
    installHashToggleOnce();

    const onKey = (e: KeyboardEvent) => {
      if (e.altKey && (e.key === "d" || e.key === "D")) {
        const next = !isDebugEnabled();
        setDebugEnabled(next);
        setEnabled(next);
        setOpen(next);
      }
    };
    window.addEventListener("keydown", onKey);

    const onFlag = (e: Event) => {
      const detail = (e as CustomEvent<boolean>).detail;
      setEnabled(!!detail);
      setOpen(!!detail);
    };
    window.addEventListener("qq:debug-changed", onFlag as any);

    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("qq:debug-changed", onFlag as any);
    };
  }, []);

  const btnStyle: React.CSSProperties = {
    position: "fixed",
    bottom: 16,
    right: 16,
    zIndex: 999999,
    borderRadius: 999,
    width: 44,
    height: 44,
    display: "grid",
    placeItems: "center",
    background: enabled ? "#7c3aed" : "#0ea5e9",
    color: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,.25)",
    cursor: "pointer",
    userSelect: "none",
    fontSize: 20,
    border: "none",
  };

  return (
    <>
      <button
        title="Toggle Debug (Alt+D)"
        style={btnStyle}
        onClick={() => {
          const next = !isDebugEnabled();
          setDebugEnabled(next);
          setEnabled(next);
          setOpen(next);
        }}
        aria-label="Toggle Debug"
      >
        🐞
      </button>

      {open && (
        <Suspense
          fallback={
            <div
              style={{
                position: "fixed",
                right: 16,
                bottom: 60,
                zIndex: 999999,
                background: "#111",
                color: "#fff",
                padding: "8px 10px",
                borderRadius: 8,
                fontSize: 12,
                opacity: 0.9,
              }}
            >
              Loading debug…
            </div>
          }
        >
          <LazyPanel />
        </Suspense>
      )}
    </>
  );
}


